import { render, staticRenderFns } from "./modalEditarDatos.vue?vue&type=template&id=109c5598"
import script from "./modalEditarDatos.vue?vue&type=script&lang=js"
export * from "./modalEditarDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports